import $ from "../libs/jquery-3.3.1.min.js"
import {BaseGameMyst} from "./base/BaseGameMyst";
import {AudioPlaylist} from '/js/app/base/AudioPlaylist.js'
import {gsap, SplitText} from "../libs/gsap/all.js";
import FontFaceObserver from '../libs/fontfaceobserver.js';
import {MystMQTT} from "./MystMQTT";
import {Howl} from "howler";
import nunjucks from "/js/libs/nunjucks.js"
import {Map} from "./components/Map";
import {Video} from "./components/Video";
import {Helper} from "./components/Helper";
import {Timer} from "./components/Timer";
import {GameA} from "./minigames/GameA";
import {GameB} from "./minigames/GameB";
import {GameC} from "./minigames/GameC";
import {GameD} from "./minigames/GameD";
import {GameE} from "./minigames/GameE";
import {GameF} from "./minigames/GameF";
import {GameG} from "./minigames/GameG";
import {GameH} from "./minigames/GameH";
import {GameTambour} from "./minigames/GameTambour";
import {Perso} from "./components/Perso";

// Constructor
export class MystQuete extends BaseGameMyst {

  constructor(queteId) {

    // Super constructor
    super(`data/myst_quete_${queteId}.json`);
    this.queteId = queteId;

    // Object class
    this.playlist = new AudioPlaylist();
    this.map = null;
    this.video = new Video();
    this.helper = new Helper();
    this.screenSaverTimer = new Timer();

    this.endingScreenTimer = new Timer();
    this.endingRedirectTimeout = false;

    this.idleHelpInterval = false;

    // Animation timeline
    this.currentTimeline = null;

    this.waitingForRFIDScan = false;

    // GSAP Config
    gsap.config({
      nullTargetWarn: false,
    });

    // Pixi games
    this.gamesClassesMap = {
      "gameA": GameA,
      "gameB": GameB,
      "gameC": GameC,
      "gameD": GameD,
      "gameE": GameE,
      "gameF": GameF,
      "gameG": GameG,
      "gameH": GameH,
      "gameTambour": GameTambour,
    }
    this.games = [];

    // Wait for all
    Promise.all([
      this.loadSettings(),
      this.loadData(),
      this.loadData("data/myst_quete_global.json")
    ]).then(() => {
      // Preload audio files
      return this.preloadAudio();
    }).then(() => {
      // Preload fonts
      return this.preloadFont();
    }).then(() => {
      // Ini nunjucks
      return this.initNunjucks();
    }).then(() => {
      // Replace strings {{ }}
      return this.renderNunjucks();
    }).then(() => {
      // Init pixi games for current Quest
      return this.initMinigame();
    }).then(() => {
      // Map init
      return this.initMap();
    }).then(() => {
      // Convert IMG to inline SVG
      return window.convertSVGToInline();
    }).then(() => {
      // Init MQTT connection
      return this.initMQTT();
    }).then(() => {
      // Real game init
      return this.initGame();
    }).catch((error) => {
      console.error("error", error)
      $("#main").append("<div id='error'>Error: " + error.message + "</div>")
    });
  }

  initMinigame() {

    return new Promise((resolve, reject) => {

      if ($(".screen[data-type='game']").length == 0) {
        resolve();
      }

      const initPromises = [];

      $(".screen[data-type='game']").each((i, el) => {
        // Let's get the data for that specific game
        const screenId = $(el).attr("id");

        for (const [type, screens] of Object.entries(this.data.content)) {
          screens.forEach((item, index) => {
            if (item.name === screenId) {
              // we found the associated data
              let gameData = {...item.game_data};
              gameData.global = {...this.data.global}

              let game = new this.gamesClassesMap[item.game_type](gameData);

              const initPromise = game.init($(el).find(".pixi-app")[0])
                .then(() => game.assetLoader())
                .then(() => game.buildStage())
                .then(() => {
                  game.canvas.addEventListener("webglcontextlost", (event) => {
                    this.restartApp();
                  }, false)

                  game.screenId = screenId;

                  if (item.game_type === "gameH") {
                    game.on("clothes_update", (e) => {
                      console.log("Received clothes update. Active clothes: ", e.detail);
                      this.animateOutGame();
                    });
                  }
                })

              initPromises.push(initPromise);
              this.games.push(game)
            }
          });
        }
      });

      // Resolve all init Promises before resolving main Promise
      Promise.all(initPromises).then(() => resolve()).catch(reject)
    });
  }

  initMap() {
    // Init map
    this.map = new Map(this.data, this);

    // Open map on reload, quick way to debug map
    if (this.settings.mapDebug) {
      this.map.enableDebug();
    }

    return this.map.init($("#draggable-map")[0]);
  }

  // To be overridden in child games
  initGame() {

    super.initGame();

    // Build perso manager
    this.perso = new Perso(this);

    // Set debug mode class
    $("body").toggleClass("debug-mode", this.debugMode);

    this.screensaverDelay = this.settings.screensaverDelay + (this.data.screensaver_delay_offset || 0); // Time BEFORE user is asked to confirm presence
    this.screenRedirectDelay = this.settings.screenRedirectDelay; // Time allowed to confirm presence
    this.endingRedirectDelay = this.settings.endingRedirectDelay; // Time allowed to make a choice in ending screen
    this.initScreenSaver();

    // Init helper
    this.helper.initHelper();

    // Listen to games complete event
    // for (const game in this.games) {
    //   const values = this.games[game];
    //
    //   if (values[0] !== null) {
    //     values[0].on("complete", () => {
    //       console.log(game + " completed!");
    //     });
    //   }
    // }

    // if (inElectron()) {
    //   this.playAudioAmbiance()
    // } else {
    //   $(window).one('click', this.playAudioAmbiance());
    // }

    // Go to first screen
    // if (inElectron()) {
    // this.initScreenSaver();
    // this.goToScreen(1);
    // } else {
    // 	$("#first-click-interact").one(this.touchEvent, $.proxy(this.initScreenSaver, this));
    // 	this.goToScreen("first-click-interact");
    // }
  };

  // On message received from RFID systems
  onMessage(e) {
    const type = e.type;
    const scanData = e.scanData;
    const screenType = $("#screen-" + this.currentScreen).data("type");
    // const screenGroup = $("#screen-" + this.currentScreen).data("screen-group");
    const needUserSwitch = typeof scanData.userSwitch !== "undefined" && scanData.userSwitch == true;
    const baseStationRFID = this.data.base_station_rfid;
    const collectableRFIDs = this.data.collectable_rfids;
    const collectedRFIDs = {};

    // Define progress states
    const baseRFIDState = scanData.progress.find((e) => e.station === baseStationRFID)?.state;

    // Harpon (18) explicitly requires a completed collectable reward
    const acceptedStates = (Number.parseInt(this.queteId) !== 18) ? ['ongoing', 'completed'] : ['completed'];
    const collectedRFIDsCount = collectableRFIDs.reduce(
      (accumulator, rfid) => accumulator + (acceptedStates.includes(scanData.progress.find((e) => e.station === rfid)?.state) ? 1 : 0),
      0,
    );

    collectableRFIDs.forEach((key) => {
      collectedRFIDs[key] = (['ongoing', 'completed'].includes(scanData.progress.find((e) => e.station === key)?.state) ? 1 : 0);
    });

    // Reset (screensaver) timer on RFID message
    this.resetTimer();

    // Prevent screen change when screen locked
    if (!this.lockScreen && type === "rfidScan") {

      // When user scan RFID

      // Play RFID scan sound
      this.audio.play(this.data.global.sounds.rfid_scan, 1.0);

      if (needUserSwitch) {
        // The user changed so let's reset and trigger its RFID
        if (this.currentScreen > 1) {
          this.animateOutReset();

          // Reset visitor
          this.currentVisitorData = null;

          // The reset function will emit a resetComplete event so we know everything is done reseting
          $(this).one("resetComplete", () => {
            // trigger the scan again now
            // clear userSwitch flag
            scanData.userSwitch = false;
            this.rfidScan(scanData)
          });

        }
      } else {

        // Same user, let's see what to do
        if (this.waitingForRFIDScan) {

          // We are waiting for scan progression (the icon is on screen and waiting for user scan)
          if (screenType === "feedback") {
            this.animateOutReset();
          }

          // Update scan progression
          const scanProgression = $("#screen-" + this.currentScreen).data("scan-progression");
          if (scanProgression) {
            this.simulator.updateBaseStationState(scanProgression);
            this.mqtt.updateBaseStationState(scanProgression);
          }

        } else {

          // No current user, it's a new user

          // Init collected rewards
          this.map.updateRewardsAndTutorial(scanData);
          // this.map.enableDebug();
          // this.map.showMap();

          // When user scan RFID
          if (this.currentScreen === 1) {
            switch (baseRFIDState) {
              case 'idle':
              case undefined:
                // user never started this quest
                this.animateOutIdle(this.data.content.initial[0].name.replace("screen-", ""));
                break;
              case "ongoing":
                if (collectedRFIDsCount >= collectableRFIDs.length) {
                  // user completed this quest
                  this.animateOutIdle(this.data.content.success[0].name.replace("screen-", ""));
                } else {
                  // user failed this quest
                  this.updateFeedback(collectedRFIDs)
                  this.animateOutIdle(this.data.content.failure[0].name.replace("screen-", ""));
                }
                break;
              case "microscope":
                this.animateOutIdle(this.data.content.success[1].name.replace("screen-", ""));
                break;
              case "completed":
                this.animateOutIdle("quest-completed");
              default:
                console.log(`Nothing to do for ${baseRFIDState}.`);
                break;
            }
          }
        }
      }
    }
  }

  // To be overridden in child games
  initScreen(screenId) {
    // Unlock screen
    //this.unlockCurrentScreen();

    // Super constructor
    if (super.initScreen(screenId) === false) {
      return false;
    }

    const $previousScreenEl = $("#screen-" + this.currentScreen);
    const previousScreenType = $previousScreenEl.data("type");

    const $screenEl = $("#screen-" + screenId);
    const screenName = $screenEl.data("name");
    const screenType = $screenEl.data("type");
    const mediaType = $screenEl.data("media-type");
    const setProgression = $screenEl.data("set-progression");

    console.log('gotoScreen', screenId, screenName, screenType);

    if (setProgression) {
      this.simulator.updateBaseStationState(setProgression);
      this.mqtt.updateBaseStationState(setProgression);
    }

    // Idle
    if (screenType === "idle") {
      this.animateInIdle($screenEl);
    } else if (["intro", "instruction", "feedback", "reward", "microscope-yes-no"].includes(screenType)) {
      // Intro / Instruction / Feedback (positive/negative) / Microscope
      this.animateInContent($screenEl, previousScreenType);
    } else if (screenType === "educative") {
      // Educative content
      this.animateInEducative($screenEl, mediaType, previousScreenType);
    } else if (screenType === "game") {
      // Game
      this.animateInGame($screenEl, previousScreenType);
    } else if (["ending", "remise-ending"].includes(screenType)) {
      // Ending
      this.animateInEnding($screenEl);
    } else if (screenType === "remise-archetype") {
      // Remise - Archetype (this function is defined in MystRemise.js)
      if (typeof this.animateInRemiseArchetype === "function") this.animateInRemiseArchetype($screenEl, previousScreenType);
    }
  }

  /**
   * Global animate out, game reset
   */
  animateOutReset() {
    this.waitingForRFIDScan = false;

    const $screenEl = $("#screen-" + this.currentScreen);

    // Prevent screen change
    // Complete this animation before allowing any screen change
    this.lockCurrentScreen();
    $screenEl.removeClass("current");

    // Reset and build timeline
    this.killTimeline();
    this.currentTimeline = gsap.timeline();

    // Disable map & helper
    this.helper.disable();
    this.map.disable();
    this.helper.hideHelperConfirmation();
    this.map.hideMap();

    // Pause & Hide screen saver
    this.pauseScreenSaver();
    $("#screen-activity-check").removeClass("shown");

    // Hide content
    this.currentTimeline.to($screenEl.find(".container, .bag, .perso-rfid"), {
      alpha: 0.0,
      duration: 0.85,
      ease: "power1.inOut"
    });
    this.currentTimeline.to($screenEl.find(".background-overlay"), {
      alpha: 0.0,
      duration: 0.85,
      ease: "power1.inOut"
    }, '<=');
    if ($screenEl.find(".container-button").length) {
      this.currentTimeline.to($screenEl.find(".container-button"), {
        alpha: 0.0,
        scale: 0,
        duration: 0.75,
        onComplete: () => {
          // Disable button animations
          $screenEl.find("button.pulse-animation, button.up-down-animation").removeClass("play-animation");
        },
        ease: "power1.inOut"
      }, '<=');
    }

    // Hide reward
    if ($screenEl.find(".reward-image")) {
      this.currentTimeline.to($screenEl.find(".reward-image"), {
        alpha: 0.0,
        scale: 0,
        duration: 0.75,
        ease: "power1.inOut",
        onComplete: () => {
          gsap.set($screenEl.find(".reward-image"), {
            x: 0,
            y: 0,
            rotate: 0
          });
          gsap.set($screenEl.find(".reward-image img"), {
            scale: 1.0
          });
        }
      }, '<=');
    }

    // Kill ending screen timer
    if ($screenEl.find(".timer-progress")) {
      // Reset redirect timeout
      if (this.endingRedirectTimeout !== false) {
        clearTimeout(this.endingRedirectTimeout);
        this.endingRedirectTimeout = false;
      }
      this.endingScreenTimer.stopTimer();
      this.currentTimeline.to($screenEl.find(".timer-progress"), {
        alpha: 0.0,
        duration: 0.75,
        ease: "power1.inOut"
      }, '<=');
    }

    // Perso
    if ($screenEl.find(".perso-remise")) {
      this.currentTimeline.to(".perso-remise", {
        alpha: 0,
        duration: 0.75,
        ease: "power2.inOut"
      });
    }

    // Hide helper and map
    this.currentTimeline.to("#map-button-container", {
      alpha: 0.0,
      duration: 0.35,
      ease: "power1.inOut"
    });
    this.currentTimeline.to("#helper-button-container", {
      alpha: 0.0,
      duration: 0.35,
      ease: "power1.inOut"
    }, '<=');

    // Move back character
    this.currentTimeline.to("#perso", {
      left: 0,
      duration: 1.40,
      force3D: true,
      ease: "power1.inOut"
    }, '<=');
    this.currentTimeline.to("#background-overlay", {
      alpha: 0.0,
      duration: 1.40,
      ease: "power1.inOut"
    }, '<=');

    // Reset game
    this.currentTimeline.add(() => {
      this.reset(1);
    });
  }

  /**
   * Animate IN IDLE screen
   * @param $screenEl
   */
  animateInIdle($screenEl) {

    // Reset and build timeline
    this.killTimeline();
    this.currentTimeline = gsap.timeline();
    $screenEl.removeClass("idle-helper-shown");

    // Idle helper - Show trigger
    this.currentTimeline.to($screenEl.find("#idle-help-button"), {
      alpha: 1.0,
      duration: 0.50,
      ease: "power1.inOut"
    });

    // make sure perso is shown in case it was hidden
    this.currentTimeline.to("#perso", {
      alpha: 1.0,
      duration: 0.75,
      ease: "power1.inOut"
    }, 0.0);

  }

  /**
   * Animate OUT IDLE screen
   * @param screenDestinationId
   */
  animateOutIdle(screenDestinationId) {
    const $screenEl = $("#screen-" + this.findScreenIdByAttribute("data-type", "idle"));
    const idleHelpShown = $screenEl.hasClass("idle-helper-shown");

    // Prevent screen change
    // Complete this animation before allowing any screen change
    this.lockCurrentScreen();
    $screenEl.removeClass("current idle-helper-shown");

    // Reset and build timeline
    this.killTimeline();
    this.currentTimeline = gsap.timeline();

    // Idle helper - Hide content
    if (idleHelpShown) {
      this.currentTimeline.to($screenEl.find("#idle-help"), {
        y: 180,
        alpha: 0.0,
        duration: 0.75,
        ease: "power1.inOut"
      });

      // Idle helper - Hide background overlay
      this.currentTimeline.to($screenEl.find(".background-overlay"), {
        alpha: 0.0,
        duration: 0.75,
        ease: "power2.inOut"
      });
    }

    // Idle helper - Hide trigger
    this.currentTimeline.to($screenEl.find("#idle-help-button"), {
      alpha: 0.0,
      duration: 0.15,
      ease: "power1.inOut"
    }, 0.0);

    // End by going to new screen
    this.currentTimeline.add(() => {
      // Allow screen change
      this.unlockCurrentScreen();
      this.goToScreen(screenDestinationId);
    });
  }

  /**
   * Animate IN Content screen
   * @param $screenEl
   * @param previousScreenType
   */
  animateInContent($screenEl, previousScreenType) {
    // Build animation timeline
    this.killTimeline();
    this.currentTimeline = gsap.timeline();

    // Prevent interaction with screen
    $screenEl.addClass("disabled");

    // Force reset texts states
    gsap.set($screenEl.find(".container-content .spoken-text-i18n .letter"), {
      alpha: 0,
      y: 0
    });

    // Move person and show background overlay
    if (previousScreenType === "idle" && !(this instanceof MystRemise)) {
      this.movePersoToLeft();
      this.currentTimeline.to("#background-overlay", {
        alpha: 1.0,
        duration: 1.25,
        ease: "power1.inOut"
      }, '<=');
    }

    // Show helper & map buttons
    const hasMap = $screenEl.data("has-map");
    const hasHelper = $screenEl.data("has-helper");
    const hasScanProgression = $screenEl.data("scan-progression") != false;

    if (hasMap) {
      this.currentTimeline.to("#map-button-container", {
        alpha: 1.0,
        duration: 0.35,
        ease: "power1.inOut"
      }, '+=0.15');

      this.currentTimeline.add(() => {
        this.map.enable();
      });
    } else {
      this.currentTimeline.to("#map-button-container", {
        alpha: 0.0,
        duration: 0.35,
        ease: "power1.inOut"
      }, '+=0.15');

      this.currentTimeline.add(() => {
        this.map.disable();
      });
    }

    if (hasHelper) {
      this.currentTimeline.to("#helper-button-container", {
        alpha: 1.0,
        duration: 0.35,
        ease: "power1.inOut"
      }, '<=');

      this.currentTimeline.add(() => {
        this.helper.enable();
      });
    } else {
      this.currentTimeline.to("#helper-button-container", {
        alpha: 0.0,
        duration: 0.35,
        ease: "power1.inOut"
      }, '-=0.35');

      this.currentTimeline.add(() => {
        this.helper.disable();
      });
    }

    // Show content
    this.currentTimeline.fromTo($screenEl.find(".container"), {
      alpha: 0.0,
      y: -180
    }, {
      alpha: 1.0,
      y: 0,
      duration: 0.60,
      ease: "power1.inOut"
    });

    // Play narration
    this.currentTimeline.add(() => this.playScreenNarration(this.currentScreen));

    // Show container title
    if ($screenEl.find(".container-title").length) {
      this.currentTimeline.fromTo($screenEl.find(".container-title"), {
        '--title-width': "0%"
      }, {
        '--title-width': "100%",
        duration: 0.45,
        ease: "power2.out"
      });
      this.currentTimeline.fromTo($screenEl.find(".container-title-inner"), {
        alpha: 0.0
      }, {
        alpha: 1.0,
        duration: 0.30,
        ease: "power1.in"
      });
    }

    // Show container text

    // We need to animate both EN and FR letters AT THE SAME TIME and SEPARATELY as their lengths are different
    // and also if we switch language we need to have the other animation running at the same time
    // Let's create a label so we have a known timing
    this.currentTimeline.addLabel("spoken-text-in");

    let letters = [];
    letters.push($screenEl.find(`.container-content .spoken-text-i18n:not(.hidden) .en .letter`));
    letters.push($screenEl.find(`.container-content .spoken-text-i18n:not(.hidden) .fr .letter`));

    for (let i = 0; i < 2; i++) {
      this.currentTimeline.fromTo(letters[i], {
        alpha: 0,
        // y: "+=25%",
      }, {
        alpha: 1,
        // y: 0,
        ease: "back",
        duration: 0.02,
        stagger: 0.04
      }, "spoken-text-in");
    }

    // Show container context images
    if ($screenEl.find(".container-context-images, .container-content .feedback-context-image").length) {
      this.currentTimeline.fromTo($screenEl.find(".container-context-images .context-image img, .container-content .feedback-context-image"), {
        alpha: 0,
        y: "-=10%",
      }, {
        alpha: 1,
        y: 0,
        duration: 0.5,
        ease: "power2.out",
        stagger: 0.25
      });
    }

    // Show container button
    if ($screenEl.find(".container-button").length) {

      // Turn on lights
      if (hasScanProgression && $screenEl.find("button.pulse-animation").length > 0) {
        this.currentTimeline.add(() => {
          this.mqtt.setLight("standby")
        });
      }

      this.currentTimeline.fromTo($screenEl.find(".container-button"), {
        alpha: 0.0,
        scale: 0.0
      }, {
        alpha: 1.0,
        scale: 1.0,
        duration: 0.75,
        ease: "power2.out"
      });

      // Enable button animations
      $screenEl.find("button.pulse-animation, button.up-down-animation").addClass("play-animation");
    }
    // Show reward image
    if ($screenEl.find(".reward-image")) {
      this.currentTimeline.fromTo($screenEl.find(".reward-image"), {
        alpha: 0.0,
        scale: 0.0
      }, {
        alpha: 1.0,
        scale: 1.0,
        duration: 0.75,
        ease: "power2.out"
      }, '<=');
    }

    // Enable interaction with screen
    this.currentTimeline.add(() => {
      $screenEl.removeClass("disabled");
      this.waitingForRFIDScan = hasScanProgression;
    });
  }

  /**
   * Animate Out Content screen
   * @param screenDestinationId
   */
  animateOutContent(screenDestinationId = false) {
    const $screenEl = $("#screen-" + this.currentScreen);

    this.waitingForRFIDScan = false;

    // Prevent screen change
    // Complete this animation before allowing any screen change
    this.lockCurrentScreen();
    $screenEl.removeClass("current");

    // Disable map & helper
    this.map.disable();
    this.helper.disable();

    // Reset and build timeline
    this.killTimeline();
    this.currentTimeline = gsap.timeline();

    // Hide content
    this.currentTimeline.to($screenEl.find(".container"), {
      y: 180,
      alpha: 0.0,
      duration: 0.75,
      ease: "power1.inOut"
    });

    // Hide container button
    if ($screenEl.find(".container-button").length) {
      this.currentTimeline.to($screenEl.find(".container-button"), {
        alpha: 0.0,
        scale: 0.0,
        duration: 0.75,
        ease: "power1.inOut"
      }, "<=");
    }

    // Hide background overlay
    if ($screenEl.find(".background-overlay").length) {
      this.currentTimeline.to($screenEl.find(".background-overlay"), {
        alpha: 0.0,
        duration: 0.75,
        ease: "power2.inOut"
      });
    }

    this.currentTimeline.add(() => {
      // Allow screen change
      this.unlockCurrentScreen();

      if (screenDestinationId) {
        this.goToScreen(screenDestinationId);
      } else {
        this.goToNextScreen();
      }
    });
  }

  /**
   * Animate out instruction screen
   */
  animateOutInstruction() {
    const screenGroup = $("#screen-" + this.currentScreen).data("screen-group");

    // Check if there is a specific screen set after scan first
    const screenAfterScan = $("#screen-" + this.currentScreen).data("screen-after-scan");

    if (screenAfterScan !== false && screenAfterScan !== "idle") {
      this.animateOutContent(screenAfterScan);
    } else {
      // Check if there is a next screen, otherwise go to idle
      let otherScreenLeft = false;
      if (screenAfterScan !== "idle") {
        for (let i = 0; i < this.data.content[screenGroup].length; i++) {
          if (this.data.content[screenGroup][i].name == "screen-" + this.currentScreen && i < this.data.content[screenGroup].length - 1) {
            otherScreenLeft = true;
            break;
          }
        }
      }
      if (otherScreenLeft) {
        // console.log("Another screen left, go to next screen.");
        this.animateOutContent();
      } else {
        // console.log("No more screen left, go to idle.");
        this.animateOutReset();
      }
    }
  }

  /**
   * Animate Out Reward screen
   * @param baseStationRFID
   */
  animateOutReward(baseStationRFID) {
    if (this.map.mapShown) return;

    // Collect reward
    if (this.currentVisitorData && baseStationRFID) {
      this.map.updateRewardsAndTutorial(this.currentVisitorData, [baseStationRFID]);
    }

    const $screenEl = $("#screen-" + this.currentScreen);
    const $rewardEl = $screenEl.find(".reward-image");
    const $mapButtonEl = $("#map-button-container");

    this.waitingForRFIDScan = false;

    // Prevent screen change
    // Complete this animation before allowing any screen change
    this.lockCurrentScreen();
    $screenEl.removeClass("current");

    // Disable map & helper
    this.map.disable();
    this.helper.disable();

    // Reset and build timeline
    this.killTimeline();
    this.currentTimeline = gsap.timeline();

    // Get distance between reward and backpack
    const distanceX = ($mapButtonEl.offset().left + $mapButtonEl.width() / 2) - ($rewardEl.offset().left + $rewardEl.width() / 2);
    const distanceY = Math.abs($rewardEl.offset().top - $mapButtonEl.offset().top);

    // Hide content animation
    this.currentTimeline.to($screenEl.find(".container-button"), {
      alpha: 0.0,
      scale: 0.0,
      duration: 0.75,
      ease: "power1.inOut"
    }, 0.0);
    this.currentTimeline.to($screenEl.find(".container"), {
      y: 180,
      alpha: 0.0,
      duration: 0.75,
      ease: "power1.inOut"
    }, 0.90);

    // Move bottle to backpack animation
    this.currentTimeline.to($rewardEl.find("img"), {
      scale: 1.1,
      duration: 0.30,
      ease: "power2.inOut"
    }, 0.30);
    this.currentTimeline.to($rewardEl, {
      rotate: -22.5,
      duration: 0.30,
      ease: "power1.inOut"
    }, 0.60);
    this.currentTimeline.to($rewardEl.find("img"), {
      scale: 1.0,
      duration: 0.30,
      ease: "power2.inOut"
    }, 0.60);
    this.currentTimeline.to($rewardEl, {
      x: distanceX,
      duration: 0.70,
      ease: "power2.inOut"
    }, 0.60);
    this.currentTimeline.to($rewardEl, {
      y: distanceY,
      duration: 1.60,
      ease: "power2.inOut"
    }, 0.60);
    this.currentTimeline.to($rewardEl.find("img"), {
      scale: 0.325,
      duration: 0.80,
      ease: "power1.inOut"
    }, 0.60);
    this.currentTimeline.to($rewardEl, {
      rotate: 0,
      duration: 0.25,
      ease: "power1.inOut"
    }, 1.05);

    this.currentTimeline.add(() => {
      // Allow screen change
      this.unlockCurrentScreen();
      this.goToNextScreen(() => {
        // Reset reward
        gsap.set([$rewardEl, $rewardEl.find("img")], {clearProps: "all"});
      });
    });
  }

  /**
   * Animate In Ending screen
   * @param $screenEl
   */
  animateInEnding($screenEl) {
    // Reset and build timeline
    this.killTimeline();
    this.currentTimeline = gsap.timeline();

    // Prevent interaction with screen
    $screenEl.addClass("disabled");

    // Show background
    this.currentTimeline.fromTo($screenEl.find(".background-overlay"), {
      alpha: 0.0
    }, {
      alpha: 1.0,
      duration: 0.75,
      ease: "power2.inOut"
    });

    // Hide helper and map
    this.currentTimeline.to("#map-button-container", {
      alpha: 0.0,
      duration: 0.75,
      ease: "power1.inOut"
    }, '<=');
    this.currentTimeline.to("#helper-button-container", {
      alpha: 0.0,
      duration: 0.75,
      ease: "power1.inOut"
    }, '<=');

    // Show content
    this.currentTimeline.set($screenEl.find(".container"), {
      alpha: 1.0
    });
    this.currentTimeline.fromTo($screenEl.find("#container-backpack-button"), {
      alpha: 0.0,
      y: -75
    }, {
      alpha: 1.0,
      y: 0,
      duration: 0.75,
      ease: "power1.inOut"
    }, '+=0.20');
    this.currentTimeline.fromTo($screenEl.find(".container-content"), {
      alpha: 0.0
    }, {
      alpha: 1.0,
      duration: 0.75,
      ease: "power1.inOut"
    });
    this.currentTimeline.fromTo($screenEl.find("#container-explore-button"), {
      alpha: 0.0,
      y: -40
    }, {
      alpha: 1.0,
      y: 0,
      duration: 0.75,
      ease: "power1.inOut"
    });
    this.currentTimeline.set($screenEl.find(".timer-progress circle"), {
      strokeDasharray: 201.062,
      strokeDashoffset: 201.062
    });
    this.currentTimeline.fromTo($screenEl.find(".timer-progress"), {
      alpha: 0.0
    }, {
      alpha: 1.0,
      duration: 0.75,
      ease: "power1.inOut"
    });

    // Enable interaction with screen
    this.currentTimeline.add(() => {
      $screenEl.removeClass("disabled");

      // Reset redirect timeout and start timer
      if (this.endingRedirectTimeout !== false) {
        clearTimeout(this.endingRedirectTimeout);
        this.endingRedirectTimeout = false;
      }
      this.endingScreenTimer.startTimer(
        $screenEl.find(".timer-progress"),
        this.endingRedirectDelay,
        () => {
          this.animateOutReset();
        });
    }, '<=');
  }

  /**
   * Animate In Educative screen
   * @param $screenEl
   * @param mediaType
   * @param previousScreenType
   */
  animateInEducative($screenEl, mediaType, previousScreenType) {
    // Build animation timeline
    this.killTimeline();
    this.currentTimeline = gsap.timeline();

    // Prevent interaction with screen
    $screenEl.addClass("disabled");

    // Move person and show background overlay
    if (previousScreenType === "idle") {
      this.movePersoToLeft();
    }

    // Show background
    this.currentTimeline.fromTo($screenEl.find(".background-overlay"), {
      alpha: 0.0
    }, {
      alpha: 1.0,
      duration: 0.75,
      ease: "power2.inOut"
    });

    // Show helper & map buttons
    const hasMap = $screenEl.data("has-map");
    const hasHelper = $screenEl.data("has-helper");
    const hasScanProgression = $screenEl.data("scan-progression") != false;

    if (hasMap) {
      this.currentTimeline.to("#map-button-container", {
        alpha: 1.0,
        duration: 0.35,
        ease: "power1.inOut"
      }, '+=0.15');

      this.currentTimeline.add(() => {
        this.map.enable();
      });
    } else {
      this.currentTimeline.to("#map-button-container", {
        alpha: 0.0,
        duration: 0.35,
        ease: "power1.inOut"
      }, '+=0.15');

      this.currentTimeline.add(() => {
        this.map.disable();
      });
    }

    if (hasHelper) {
      this.currentTimeline.to("#helper-button-container", {
        alpha: 1.0,
        duration: 0.35,
        ease: "power1.inOut"
      }, '<=');

      this.currentTimeline.add(() => {
        this.helper.enable();
      });
    } else {
      this.currentTimeline.to("#helper-button-container", {
        alpha: 0.0,
        duration: 0.35,
        ease: "power1.inOut"
      }, '-=0.35');

      this.currentTimeline.add(() => {
        this.helper.disable();
      });
    }

    // Show content
    this.currentTimeline.fromTo($screenEl.find(".container"), {
      alpha: 0.0,
      y: -180
    }, {
      alpha: 1.0,
      y: 0,
      duration: 0.60,
      ease: "power1.inOut"
    });

    // Show content
    this.currentTimeline.fromTo($screenEl.find(".container-content"), {
      alpha: 0.0,
    }, {
      alpha: 1.0,
      duration: 0.60,
      ease: "power1.inOut"
    });

    // Show container title
    // if ($screenEl.find(".container-title").length) {
    //   this.currentTimeline.fromTo($screenEl.find(".container-title"), {
    //     '--title-width': "0%"
    //   }, {
    //     '--title-width': "100%",
    //     duration: 0.45,
    //     ease: "power2.out"
    //   });
    //   this.currentTimeline.fromTo($screenEl.find(".container-title-inner"), {
    //     alpha: 0.0
    //   }, {
    //     alpha: 1.0,
    //     duration: 0.30,
    //     ease: "power1.in"
    //   });
    // }

    // Start video early so we don't wait too long on a black screen
    if (mediaType === "video") {
      this.currentTimeline.add(() => {
        // console.log("START VIDEO NOW")
        this.video.startVideo($screenEl)
      });
    }

    if ($screenEl.find(".container-note").length) {
      this.currentTimeline.fromTo($screenEl.find(".container-note"), {
        y: "+=100%"
      }, {
        y: 0,
        duration: 1.50,
        ease: "power1.inOut",
        immediateRender: true
      }, "+=0.5");

      this.currentTimeline.fromTo($screenEl.find(".container-note"), {
        autoAlpha: 0
      }, {
        autoAlpha: 1,
        duration: 0.1,
        ease: "linear",
        immediateRender: true
      }, '<=');
    }
    // Show container button
    if ($screenEl.find(".container-button").length) {
      this.currentTimeline.fromTo($screenEl.find(".container-button"), {
        alpha: 0.0,
        scale: 0.0
      }, {
        alpha: 1.0,
        scale: 1.0,
        duration: 0.75,
        ease: "power2.out"
      });

      // Enable button animations
      $screenEl.find("button.pulse-animation, button.up-down-animation").addClass("play-animation");
    }

    // Enable interaction with screen
    this.currentTimeline.add(() => {
      $screenEl.removeClass("disabled");
      this.waitingForRFIDScan = hasScanProgression;
    });


    // // Callback function
    // if (callback !== undefined && typeof callback === "function") {
    //   callback();
    // }
  }

  /**
   * Animate Out Content screen
   * @param screenDestinationId
   */
  animateOutEducative(screenDestinationId = false) {
    const $screenEl = $("#screen-" + this.currentScreen);
    const mediaType = $screenEl.data("media-type");

    this.waitingForRFIDScan = false;

    // Stop video if needed
    if (mediaType === "video") {
      this.video.stopVideo();
    }

    // Prevent screen change
    // Complete this animation before allowing any screen change
    this.lockCurrentScreen();
    $screenEl.removeClass("current");

    // Disable map & helper
    this.map.disable();
    this.helper.disable();

    // Reset and build timeline
    this.killTimeline();
    this.currentTimeline = gsap.timeline();

    // Hide content
    this.currentTimeline.to($screenEl.find(".container"), {
      y: 180,
      alpha: 0.0,
      duration: 0.75,
      ease: "power1.inOut"
    });

    // Hide container button
    if ($screenEl.find(".container-button").length) {
      this.currentTimeline.to($screenEl.find(".container-button"), {
        alpha: 0.0,
        scale: 0.0,
        duration: 0.75,
        ease: "power1.inOut"
      }, "<=");
    }

    // Hide background overlay
    if ($screenEl.find(".background-overlay").length) {
      this.currentTimeline.to($screenEl.find(".background-overlay"), {
        alpha: 0.0,
        duration: 0.75,
        ease: "power2.inOut"
      });
    }

    this.currentTimeline.add(() => {
      // Allow screen change
      this.unlockCurrentScreen();

      if (screenDestinationId) {
        this.goToScreen(screenDestinationId);
      } else {
        this.goToNextScreen();
      }
    });
  }

  /**
   * Animate In Game screen
   * @param $screenEl
   * @param previousScreenType
   */
  animateInGame($screenEl, previousScreenType) {
    // Reset and build timeline
    this.killTimeline();
    this.currentTimeline = gsap.timeline();

    const hidePerson = typeof $screenEl.data("hide-person") !== "undefined" ? $screenEl.data("hide-person") : false;

    // Reset game conclusion position
    const specialGames = ["gameTambour"];


    // Move person and show background overlay
    if (previousScreenType === "idle") {
      this.movePersoToLeft();
    }

    // this.currentTimeline.set($screenEl.find(".game-conclusion"), {y: 0});
    // Show background
    this.currentTimeline.fromTo($screenEl.find(".background-overlay"), {
      alpha: 0.0
    }, {
      alpha: 1.0,
      duration: 0.75,
      ease: "power2.inOut"
    });

    if (hidePerson === true) {
      this.currentTimeline.to("#perso", {
        alpha: 0.0,
        duration: 0.75,
        ease: "power1.inOut"
      }, '<=');
    }

    // Hide helper and map
    this.currentTimeline.to("#map-button-container", {
      alpha: 0.0,
      duration: 0.75,
      ease: "power1.inOut"
    }, '<=');
    this.currentTimeline.to("#helper-button-container", {
      alpha: 0.0,
      duration: 0.75,
      ease: "power1.inOut"
    }, '<=');
    this.currentTimeline.add(() => {
      $(this.games).filterByProperty("screenId", $screenEl.attr("id"))[0].beforeAnimateIn();
    }, '<=');

    this.currentTimeline.add(() => {
      this.map.disable();
    });

    if (!specialGames.includes($screenEl.data("game-type"))) {

      // Show content
      this.currentTimeline.fromTo($screenEl.find(".game-container"), {
        alpha: 1.0,
        y: "-110%"
      }, {
        alpha: 1.0,
        y: 0,
        duration: 1,
        ease: "power3.out"
      });

    } else {
      // special games
      if ($screenEl.data("game-type") == "gameTambour") {

        // Show content
        this.currentTimeline.fromTo($screenEl.find(".game-container"), {
          alpha: 0.0,
        }, {
          alpha: 1.0,
          duration: 1,
          ease: "power3.out"
        });

        this.currentTimeline.fromTo($screenEl.find(".game-instructions-inner"), {
          alpha: 1.0,
          y: "-150%"
        }, {
          alpha: 1.0,
          y: 0,
          duration: 1,
          ease: "power3.out"
        }, '<=');

        this.currentTimeline.fromTo($screenEl.find(".game-instructions-inner .container-button"), {
          alpha: 0.0,
          scale: 0.0
        }, {
          alpha: 1.0,
          scale: 1.0,
          duration: 0.75,
          ease: "power2.out"
        });

      }

    }

    // Play narration
    this.currentTimeline.add(() => this.playScreenNarration(this.currentScreen));

    this.currentTimeline.add(() => {
      $(this.games).filterByProperty("screenId", $screenEl.attr("id"))[0].begin();
    });
  }

  /**
   * Animate Out Game screen
   */
  animateOutGame(screenDestinationId = false) {
    const $screenEl = $("#screen-" + this.currentScreen);
    this.waitingForRFIDScan = false;

    const hidePerson = typeof $screenEl.data("hide-person") !== "undefined" ? $screenEl.data("hide-person") : false;

    // Reset game conclusion position
    const specialGames = ["gameTambour"];

    // Prevent screen change
    // Complete this animation before allowing any screen change
    this.lockCurrentScreen();
    $screenEl.removeClass("current");

    // Reset and build timeline
    this.killTimeline();
    this.currentTimeline = gsap.timeline();

    if (!specialGames.includes($screenEl.data("game-type"))) {
      // Hide content
      this.currentTimeline.fromTo($screenEl.find(".game-container"), {
        y: 0
      }, {
        y: "125%",
        duration: 1.25,
        delay: 0.25,
        ease: "power2.inOut"
      });

    } else {
      // special games
      if ($screenEl.data("game-type") == "gameTambour") {

        // Show content
        this.currentTimeline.fromTo($screenEl.find(".game-container"), {
          alpha: 1.0,
        }, {
          alpha: 0.0,
          duration: 1,
          ease: "power3.out"
        });

      }
    }

    // Hide background
    this.currentTimeline.fromTo($screenEl.find(".background-overlay"), {
      alpha: 1.0
    }, {
      alpha: 0.0,
      duration: 0.75,
      ease: "power2.inOut"
    }, '<=');

    if (hidePerson === true) {
      // revert to shown
      this.currentTimeline.to("#perso", {
        alpha: 1.0,
        duration: 0.75,
        ease: "power1.inOut"
      }, '<=');
    }

    this.currentTimeline.add(() => {
      // Allow screen change
      this.unlockCurrentScreen();

      if (screenDestinationId) {
        this.goToScreen(screenDestinationId);
      } else {
        this.goToNextScreen();
      }
    });
  }

  /**
   * This will display dynamic failure message, when a specific number of collectable is needed.
   * This is used mainly in Quest 1 (Lagopèdes)
   */
  updateFeedback(collectedRFIDs) {
    const $failureScreen = $(".screen[data-type='feedback'][data-feedback-type='failure']");

    if ($failureScreen.find(".progress-steps").length > 0) {
      $failureScreen.find(".progress-steps .progress-step").each((i, n) => $(n).toggleClass("completed", !!parseInt(collectedRFIDs[$(n).data("step-rfid")])));
    }
  }

  /**
   *  Move perso to left and show background overlay
   */
  movePersoToLeft() {
    const persoXOffset = this.data.perso_x_offset;
    this.currentTimeline.to("#perso", {
      left: -409 + persoXOffset,
      duration: 1.40,
      force3D: true,
      ease: "power1.inOut"
    });
  }

  /**
   *  Used in idle screen to show idle screen help overlay
   */
  showIdleHelp() {

    const $screenEl = $("#screen-" + this.currentScreen);

    // Do not proceed ig help is already shown or lock
    if($screenEl.hasClass("idle-helper-shown") || this.lockScreen) return;
    $screenEl.addClass("idle-helper-shown");

    // Reset and build timeline
    this.killTimeline();
    this.currentTimeline = gsap.timeline();

    // Make sure that the close button is there.
    // In some case, the close button was desappering forever from applications.
    this.currentTimeline.set($screenEl.find("#idle-help .container-button"), {
      autoAlpha: 1.0,
      scale: 1,
    });

    // Show background
    this.currentTimeline.fromTo($screenEl.find(".background-overlay"), {
      alpha: 0.0
    }, {
      alpha: 1.0,
      duration: 0.75,
      ease: "power2.inOut"
    });

    // Show content
    this.currentTimeline.fromTo($screenEl.find("#idle-help"), {
      y: 180,
      alpha: 0.0,
    }, {
      y: 0,
      alpha: 1.0,
      duration: 0.60,
      ease: "power1.inOut"
    });

    // Stagger animation for content inside
    this.currentTimeline.fromTo($screenEl.find("#idle-help .container-content h2, #idle-help .steps > .step"), {
      alpha: 0,
      y: "-=7.5%",
    }, {
      alpha: 1,
      y: 0,
      duration: 0.5,
      ease: "power1.out",
      stagger: 0.35
    });

    // Create an interval that check if the idle help overlay should be closed
    if (this.idleHelpInterval !== false) clearInterval(this.idleHelpInterval);
    this.idleHelpInterval = setInterval(() => {
      const noActionSince = millis() - this.lastClick;
      // Hackish way to create another interval check with this.lastClick by making sure that this check happens before shouldReset() check.
      // This is why we make the delay shorter by 0.5sec and run the check even faster (0.25sec)
      if (noActionSince > ((this.screensaverDelay * 1000) - 500) && this.screensaverDelay != -1) {
        this.hideIdleHelp()
      }
    }, 250);
  }


  /**
   *  Used in idle screen to close help overlay
   */
  hideIdleHelp() {
    // Reset and build timeline
    this.killTimeline();
    this.currentTimeline = gsap.timeline();

    const $screenEl = $("#screen-" + this.currentScreen);
    $screenEl.removeClass("idle-helper-shown");

    // Hide content
    this.currentTimeline.to($screenEl.find("#idle-help"), {
      y: 180,
      alpha: 0.0,
      duration: 0.75,
      ease: "power1.inOut"
    });

    // Hide background overlay
    this.currentTimeline.to($screenEl.find(".background-overlay"), {
      alpha: 0.0,
      duration: 0.75,
      ease: "power2.inOut"
    });

    // Stop checking for autoclose
    if (this.idleHelpInterval !== false) {
      clearInterval(this.idleHelpInterval);
      this.idleHelpInterval = false;
    }
  }

  /**
   * Animate In screen saver overlay
   */
  animateInScreenSaver() {
    const $screenSaverEl = $("#screen-activity-check");
    $screenSaverEl.addClass("shown");

    // Timeline not needed for this specific case
    gsap.fromTo($screenSaverEl.find(".inner"), {
      alpha: 0.0,
      scale: 0.75
    }, {
      alpha: 1.0,
      scale: 1.0,
      duration: 0.5,
      delay: 0.20,
      ease: "power1.inOut"
    });
    gsap.fromTo($screenSaverEl.find(".opacity-container"), {
      alpha: 0.0
    }, {
      alpha: 1.0,
      duration: 0.25,
      delay: 0.70,
      ease: "power1.inOut"
    });

    // Start timer
    setTimeout(() => {
      this.screenSaverTimer.startTimer($screenSaverEl.find(".timer-progress"), this.screenRedirectDelay - 0.95);
    }, 700);
  }

  /**
   * Go to screen saver
   */
  goToScreenSaver() {
    // We're already at the intro, no need to do this again
    if (this.currentScreen && (this.currentScreen > 1 || this.currentScreen === 'quest-completed') && !this.lockScreenSaver) {
      this.pauseScreenSaver();

      // Ask user if still there
      this.animateInScreenSaver();

      // Clear any other redirect timeout to make sure that only one timer is running
      if (this.redirectTimeout !== false) {
        clearTimeout(this.redirectTimeout);
        this.redirectTimeout = false;
      }

      // Init the redirect timeout
      this.redirectTimeout = setTimeout(() => {
        $("#screen-activity-check").removeClass("shown");
        this.animateOutReset();
      }, this.screenRedirectDelay * 1000);
    }
  }

  /**
   * When user is asked if he's still there
   * @param stillThere
   */
  screenActivityCheck(stillThere = false) {
    if (stillThere) {
      // Return to the game
      // Reset redirect timeout
      if (this.redirectTimeout !== false) {
        clearTimeout(this.redirectTimeout);
        this.redirectTimeout = false;
      }

      $("#screen-activity-check").removeClass("shown");
      this.unpauseScreenSaver();
    } else {
      // Reset the game
      $("#screen-activity-check").removeClass("shown");
      this.animateOutReset();
    }

    // Kill screen saver timer
    this.screenSaverTimer.stopTimer();
  }

  /**
   * Return screen id using attribute and value
   * @param attribute
   * @param attributeValue
   * @returns {*|boolean}
   */
  findScreenIdByAttribute(attribute, attributeValue) {
    const elementFound = $(`.screen[${attribute}="${attributeValue}"]`).eq(0);

    if (elementFound.length) {
      return parseInt(elementFound.attr("id").replace("screen-", ""));
    } else {
      return false;
    }
  }

  /**
   * Kill/reset timeline before building a new one
   */
  killTimeline() {
    if (this.currentTimeline) {
      this.currentTimeline.kill();
      this.currentTimeline = null;
    }
  }

  /**
   * Reset function, used to go back clean version of the game
   * @param screenId
   * @returns {boolean}
   */
  reset(screenId) {
    console.log("RESET");

    // Reset redirect timeout
    if (this.redirectTimeout !== false) {
      clearTimeout(this.redirectTimeout);
      this.redirectTimeout = false;
    }

    // reset visitor
    this.waitingForRFIDScan = false;
    this.currentVisitorData = null;

    // Reset video
    this.video.reset();

    // Reset interface
    this.map.reset();
    this.helper.reset();

    // Reset variable

    // Things that reset after goToScreen
    const resetCallback = () => {
      // Reset failure screen text
      // Reset failure screen progress counter
      const $failureScreen = $(".screen[data-type='feedback'][data-feedback-type='failure']");
      if ($failureScreen.find(".progress-steps")) {
        $failureScreen.find(".progress-steps .progress-step").removeClass("completed");
      }

      // Reset games
      this.games.forEach(game => {
        if (game.reset !== undefined && typeof game.reset === "function") {
          game.reset();
        }
      });

      // Turn on lights
      this.mqtt.setLight("standby")
    }

    // Allow screen change
    this.unlockCurrentScreen();
    // Unpause screen saver timer
    this.unpauseScreenSaver();

    if (typeof screenId == "undefined") {
      resetCallback();
    }

    // Super
    if (super.reset(screenId, resetCallback) === false) {
      return false;
    }
  }
}
